<div mat-dialog-title>
  @switch (data) {
    @case (VideoGuide.kpi) {
      <span>{{ 'VIDEO_TUTORIAL_ANALYTICS_MODULE' | translate }}</span>
    }
    @case (VideoGuide.map) {
      <span>{{ 'VIDEO_TUTORIAL_MAP_TRACKING' | translate }}</span>
    }
    @case (VideoGuide.alert) {
      <span>{{ 'VIDEO_TUTORIAL_ALERTS_MODULE' | translate }}</span>
    }
    @case (VideoGuide.admin) {
      <span>{{ 'VIDEO_TUTORIAL_ADMIN_MODULE' | translate }}</span>
    }
  }
  <button mat-icon-button
    mat-dialog-close>
    <fa-icon icon="times"></fa-icon>
  </button>
</div>
<div mat-dialog-content>
  <video controls
    aria-describedby="">
    @for (video of sources; track video) {
      <source
        [src]="video.src"
        [type]="video.type">
    }
    @for (sub of subtitles; track sub) {
      <track
        [label]="sub.label"
        kind="captions"
        [srclang]="sub.lang"
        [src]="sub.url"
        [default]="sub.default">
    }
    <span>Your browser does not support the video tag.</span>
  </video>
</div>
